/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ deltaText: NonNullable<unknown>, pct: NonNullable<unknown> }} Workout_Highlights_Plan_Day_DeltaInputs */

const en_us2_workout_highlights_plan_day_delta = /** @type {(inputs: Workout_Highlights_Plan_Day_DeltaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText} (${i?.pct})`)
};

const pt_br2_workout_highlights_plan_day_delta = /** @type {(inputs: Workout_Highlights_Plan_Day_DeltaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText} (${i?.pct})`)
};

const es_419_workout_highlights_plan_day_delta = /** @type {(inputs: Workout_Highlights_Plan_Day_DeltaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText} (${i?.pct})`)
};

const pt_pt2_workout_highlights_plan_day_delta = /** @type {(inputs: Workout_Highlights_Plan_Day_DeltaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText} (${i?.pct})`)
};

const fr_fr2_workout_highlights_plan_day_delta = /** @type {(inputs: Workout_Highlights_Plan_Day_DeltaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText} (${i?.pct})`)
};

const de_de2_workout_highlights_plan_day_delta = /** @type {(inputs: Workout_Highlights_Plan_Day_DeltaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText} (${i?.pct})`)
};

const it_it2_workout_highlights_plan_day_delta = /** @type {(inputs: Workout_Highlights_Plan_Day_DeltaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText} (${i?.pct})`)
};

/**
* | output |
* | --- |
* | "{deltaText} ({pct})" |
*
* @param {Workout_Highlights_Plan_Day_DeltaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_highlights_plan_day_delta = /** @type {((inputs: Workout_Highlights_Plan_Day_DeltaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Highlights_Plan_Day_DeltaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_highlights_plan_day_delta(inputs)
	if (locale === "es-419") return es_419_workout_highlights_plan_day_delta(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_highlights_plan_day_delta(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_highlights_plan_day_delta(inputs)
	if (locale === "de-DE") return de_de2_workout_highlights_plan_day_delta(inputs)
	if (locale === "it-IT") return it_it2_workout_highlights_plan_day_delta(inputs)
	return en_us2_workout_highlights_plan_day_delta(inputs)
});
export { workout_highlights_plan_day_delta as "workout-highlights.plan_day_delta" }